module.exports = __webpack_public_path__ + "img/2.efdf9ad4.jpg";